class BESSAppProjectSiteTypeDependencyEvent extends BESSAppDependencyEvent {
    static name = "BESSAppProjectSiteTypeDependencyEvent";

    constructor(siteType, changing = false) {
        super(BESSAppProjectSiteTypeDependencyEvent.name, siteType, changing);
    }
}